/**
 * Serviço para operações relacionadas a endereços
 * Migrado de App.js para estrutura modular
 * Usa OpenStreetMap Nominatim API (gratuita)
 */

/**
 * Busca endereços usando OpenStreetMap Nominatim
 * @param {string} query - Termo de busca do endereço
 * @returns {Promise<{success: boolean, items: Array}>}
 */
export const searchAddress = async (query) => {
  if (!query || query.length < 3) {
    return {
      success: true,
      items: []
    };
  }

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&addressdetails=1&countrycodes=br`,
      {
        headers: {
          'User-Agent': 'PainelOS/1.0' // Nominatim requer User-Agent
        }
      }
    );

    if (!response.ok) {
      throw new Error('Erro ao buscar endereços');
    }

    const data = await response.json();
    return {
      success: true,
      items: data || []
    };
  } catch (error) {
    console.error('Erro ao buscar endereços:', error);
    return {
      success: false,
      items: [],
      error: error.message
    };
  }
};

